export const getDarkMode = () => {
    const darkModeValue = localStorage.getItem('isDarkMode');
    return darkModeValue === 'true';
};